import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useSession } from "@/lib/auth/client";

interface CreditsResponse {
  balance: number;
  hasPurchasedTrial?: boolean;
  hasPurchasedAnyPack?: boolean;
  isCompanyMember?: boolean;
  companyId?: string;
  companyName?: string;
  role?: "owner" | "admin" | "staff";
  freePreviewsUsed?: number;
  freePreviewsRemaining?: number;
  hasInFlightFreePreview?: boolean;
}

export function useCredits() {
  const { data: session } = useSession();
  const isAuthenticated = !!session?.user;

  return useQuery<CreditsResponse>({
    queryKey: ["credits"],
    queryFn: async () => {
      const response = await fetch("/api/credits");
      if (!response.ok) {
        throw new Error("Failed to fetch credits");
      }
      return response.json();
    },
    enabled: isAuthenticated, // Only fetch when user is authenticated
    staleTime: 60_000, // keep credits warm for 1 minute
    gcTime: 5 * 60_000,
  });
}

export function useInvalidateCredits() {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: ["credits"] });
}
